/* © Facilogi.  See LICENSE file for full copyright & licensing details. */

import { ModelFieldValueTranslations } from "App/IOC/Services";
import Columns from "./Columns";
import Fields from "./Fields";
import Filters from "./Filters";

export default {
    Columns,
    Fields,
    Filters,
    FindByModelAndField: ModelFieldValueTranslations.FindByModelAndField,
    Update: ModelFieldValueTranslations.Update
}
